import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const thunkErrorHandler = async <T>(
  fn: () => Promise<T>,
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
  rejectWithValue: (value: unknown) => any,
  errorTarget: 'page' | 'modal' = 'page',
  onError?: () => void
): Promise<T> => {
  try {
    return await fn();
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        for: errorTarget,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    onError && onError();

    return rejectWithValue(errors);
  }
};

export const thunkErrorHandlerWithoutSdk = async <T>(
  fn: () => Promise<T>,
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
  rejectWithValue: (value: unknown) => any,
  errorTarget: 'page' | 'modal' = 'page'
): Promise<T> => {
  try {
    return await fn();
  } catch (error: any) {
    const errors = JSON.parse(error.response.data).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        for: errorTarget,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
